export default "__VITE_ASSET__fa7cae21__"